export type MaybeBoolean = boolean | string | null | undefined;

export function evalMaybeBoolean(value: MaybeBoolean) {
  return value === true || value === '';
}
